import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-select-preview',
    templateUrl: './select-preview.component.html',
    styleUrls: ['./select-preview.component.scss'],
    standalone: false
})
export class SelectPreviewComponent {
  _title: string;
  @Input() set title(_title: Object | string) {
    if (typeof _title === 'string') {
      this._title = _title;
    } else {
      this._title = '';
    }
  }
  @Input() subtitle: string;
  @Input() image: string;

  fallbackImage = '/assets/img/artist.png';

  @Output() onRemove = new EventEmitter();

  removeClicked() {
    this.onRemove.emit();
  }
}
